module.exports = {"id":"189153","name":"Mauro Díaz","rating":"74","photo":"./data/images/photos/2/189153.png","club":{"name":"FC Dallas","logo":"./data/images/clubs/FCDallas.png"},"positions":["MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MauroDiaz0.json
// module id = 2926
// module chunks = 0